export default __webpack_public_path__ + "static/media/easiest-way.7a9cdc4b.svg";